export class Group{
  constructor(
    public displayName: string,
    public value: string,
    public selected: boolean
  ){}
}
